/* eslint-disable react/button-has-type */
import React from 'react';

import Link from './Link';
import {Spinner} from './Spinner';
import {cx} from '../util';

export const ButtonTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  SKEUOMORPHIC: 'skeuomorphic',
};

export const ButtonSizes = {
  SMALL: 'small',
  REGULAR: 'regular',
  LARGE: 'large',
};

export default function Button(props) {
  const {
    children,
    disabled = false,
    loading = false,
    onClick,
    className,
    href,
    forceAnchor,
    target,
    style,
    type = 'button',
    buttonType = ButtonTypes.PRIMARY,
    size = ButtonSizes.REGULAR,
    ...rest
  } = props;

  const classes = cx(`
    inline-flex
    items-center
    justify-center
    border
    leading-4
    font-medium
    rounded-md
    focus:outline-none
    focus:ring-2
    focus:ring-offset-2
    focus:ring-indigo-500`, {
    'cursor-pointer': !disabled && !loading,
    'border-transparent shadow-sm text-white bg-indigo-600 hover:bg-indigo-700': buttonType === ButtonTypes.PRIMARY && !disabled,
    'border-gray-300 shadow-sm text-gray-700 bg-white hover:bg-gray-50': buttonType === ButtonTypes.SECONDARY && !disabled,
    'border-transparent text-indigo bg-transparent': buttonType === ButtonTypes.TERTIARY && !disabled,
    'bg-gradient-to-b from-indigo-500 to-indigo-700 border border-indigo-700 text-white shadow-md hover:shadow-lg active:shadow-inner': buttonType === ButtonTypes.SKEUOMORPHIC && !disabled,
    'border-transparent bg-gray-300 text-gray-600': (buttonType === ButtonTypes.PRIMARY || buttonType === ButtonTypes.SECONDARY || buttonType === ButtonTypes.SKEUOMORPHIC) && disabled,
    'bg-transparent border-transparent text-gray-400': buttonType === ButtonTypes.TERTIARY && disabled,
    'px-2.5 py-1 text-xs leading-4': size === ButtonSizes.SMALL,
    'px-3 py-2 text-sm leading-4': size === ButtonSizes.REGULAR,
    'px-5 py-3 text-base leading-4': size === ButtonSizes.LARGE,
  }, className);

  if (href) {
    return (
      <Link
        className={classes}
        onClick={onClick || undefined}
        href={href}
        forceAnchor={forceAnchor}
        disabled={disabled || loading}
        target={target}
        style={style}
      >
        <>
          {children}
          {loading && <Spinner className="ml-2 border-3 h-4 w-4" />}
        </>
      </Link>
    );
  }

  return (
    <button
      type={type || 'button'}
      className={classes}
      onClick={onClick || undefined}
      disabled={disabled || loading}
      style={style}
      {...rest}
    >
      {children}
      {loading && <Spinner className="ml-2 border-3 h-4 w-4" />}
    </button>
  );
}

